import { BMotionObject } from './BMotionObject';
import { NumPair, Point } from '../Misc/Utils';
import { ObjectType } from './ObjectTypeEnum';

export class BText extends BMotionObject{

    protected readonly TYPE = ObjectType.TEXT;

    protected _text: string = ""
    get text(): string {
        return this._text;
    }
    set text(ttext: string){
        if(ttext){
            this._text = ttext;
            this.recheckWH = true;
        }
    }

    font: string = 'serif'
    
    protected _size: number = 40
    get size(): number{
        return this._size;
    }
    set size(tsize: number){
        if(tsize && Number(tsize)!=NaN){
            this._size = tsize;
            this.recheckWH = true;
        }
    }

    private recheckWH:Boolean = true;

    constructor(tcenter: NumPair, txt: string, frameRange: NumPair, font: string){
        super(tcenter, [0,0], frameRange);
        this.text = txt;
        this.font = font;
        this.recheckWH = true;
    }

    protected scale(curMousePoint: Point): void{
        var oldWH = [this.wh[0], this.wh[1]];
        super.scale(curMousePoint);
        //this._size = this.wh[1];
        if(this.wh[0] > oldWH[0]){
            this.size += 0.4;
        }else{
            this.size -= 0.4;
        }
    }

    private preTextDraw(canvasCtx: CanvasRenderingContext2D){
        canvasCtx.textBaseline = 'hanging';
        ///if(this.recheckWH){
            canvasCtx.font = this.size+'px '+this.font;
        /*}else{
            canvasCtx.font = this.wh[1]+'px '+this.font;
        }*/
    }

    private postTextDraw(canvasCtx: CanvasRenderingContext2D){
        if(this.recheckWH){ //first time when wh is not set
            this.setWH([
                canvasCtx.measureText(this.text).width, canvasCtx.measureText(this.text).actualBoundingBoxDescent
                //this.size * 0.82
            ]);
            this.recheckWH = false;
            console.log("text wh set as:"+this.wh);
            console.log("w,bbd:"+canvasCtx.measureText(this.text).width+","+canvasCtx.measureText(this.text).actualBoundingBoxDescent);
            //console.log("l,r:"+canvasCtx.measureText(this.text).actualBoundingBoxLeft+","+canvasCtx.measureText(this.text).actualBoundingBoxRight);
            //console.log("ha,hd:"+canvasCtx.measureText(this.text).emHeightAscent+","+canvasCtx.measureText(this.text).emHeightDescent);
            //console.log("alp,han:"+canvasCtx.measureText(this.text).alphabeticBaseline+","+canvasCtx.measureText(this.text).hangingBaseline+","+canvasCtx.measureText(this.text).ideographicBaseline);
        }
    }
    
    private drawText(canvasCtx: CanvasRenderingContext2D){
        this.colorMgr.setupCanvas(canvasCtx);
        canvasCtx.strokeText(this.text, -this.wh[0]/2, -this.wh[1]/2);
        canvasCtx.fillText(this.text, -this.wh[0]/2, -this.wh[1]/2);
    }

    protected justDrawObj(canvasCtx : CanvasRenderingContext2D): void{
        this.preTextDraw(canvasCtx);
        this.drawText(canvasCtx);
        this.postTextDraw(canvasCtx);
    }

    isColourable(): Boolean{
        return true;
    }
    
    /*protected drawObj(canvasCtx: CanvasRenderingContext2D, playing: boolean, curFrame: number): void {
        this.preTextDraw(canvasCtx);

        if(this.hasMotions()){
            //draw animated pos
            canvasCtx.save();
            
            let computedVals = this.transformCanvas(canvasCtx);
            let computedSize = computedVals[1];
            let alpha = computedVals[2][1]; 

            canvasCtx.globalAlpha = alpha;

            this.drawText(canvasCtx);

            canvasCtx.globalAlpha = Constants.OPAQUE;
            canvasCtx.restore();

        }else{
            //draw static pos
            canvasCtx.save();
            canvasCtx.translate(this.centre[0], this.centre[1]);
            canvasCtx.rotate(this.angle);
            
            this.drawText(canvasCtx);

            canvasCtx.restore();
        }

        this.postTextDraw(canvasCtx);
    } */
    
    public clone(): BText {
        var dupCenter = [this.getCentre()[0], this.getCentre()[1]];
        var dupFrameRange = [this.getFrameRange()[0], this.getFrameRange()[1]];
        var dupObj : BText = new BText(dupCenter as NumPair, this.text, dupFrameRange as NumPair, this.font);
        dupObj.size = this.size;
        super.duplicate(dupObj);
        return dupObj;
    }


}